<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('paymentDetail.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('paymentDetail.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('paymentDetail.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('yearlyPaymentList.branchName')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.branch_id"
                        :options="branches"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('paymentDetail.mainProgram')
                      }}</label>
                      <a-select
                        style="width:100%"
                        v-model.number="model.acp_id"
                        :options="main_programs"
                        @change="fetchTeacher"
                      ></a-select>
                      <div class="validate" v-if="errors.has('acp_id')">
                        {{ errors.first('acp_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('paymentDetail.teacher')
                      }}</label>
                      <a-select
                        style="width:100%"
                        v-model.number="model.teacher_id"
                        :options="teacher_lists"
                      ></a-select>
                      <div class="validate" v-if="errors.has('teacher_id')">
                        {{ errors.first('teacher_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('paymentDetail.studyTime')
                      }}</label>
                      <a-select
                        style="width:100%"
                        v-model.number="model.ac_st_id"
                        :options="study_time_option"
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_st_id')">
                        {{ errors.first('ac_st_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('paymentDetail.date')
                      }}</label>
                      <a-range-picker
                        style="width:100%"
                        v-model="model.date_range"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                      />
                      <div class="validate" v-if="errors.has('date_range')">
                        {{ errors.first('date_range') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 ts-text-right">
                      <ts-button
                        color="success"
                        class="btn-block"
                        @click.prevent="exportExcel"
                        :waiting="exporting"
                        ><i class="far fa-file-excel"></i>
                        {{ $t('export') }}</ts-button
                      >
                    </div>
                    <div class="col-md-6 ts-text-right">
                      <ts-button
                        color="danger"
                        class="btn-block"
                        @click.prevent="preview"
                        :waiting="waiting"
                        ><i class="far fa-file-pdf"></i>
                        {{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('paymentDetail.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'paymentDetail',
  data() {
    return {
      loading: false,
      waiting: false,
      src: '',
      errors: new Errors(),
      main_programs: [],
      exporting: false,
      branches: [],
      teacher_lists: [{ value: 0, label: 'All' }],
      study_time_resources: [],
      model: {
        branch_id: null,
        acp_id: null,
        teacher_id: 0,
        ac_st_id: 0,
        date_range: [
          moment().format('DD-MM-YYYY'),
          moment().format('DD-MM-YYYY')
        ]
      }
    }
  },
  computed: {
    study_time_option() {
      let result = this.study_time_resources
        .filter(s => s.teacher_id == this.model.teacher_id)
        .map(el => ({
          value: el.ac_st_id,
          label: el.study_time
        }))
      return [{ value: 0, label: 'All' }, ...result]
    }
  },
  created() {
    this.fetchMainProgram()
  },
  methods: {
    ...mapActions('reportPayment', [
      'getBranch',
      'getMainProgram',
      'getTeacher',
      'paymentDetail',
      'paymentDetailExcel'
    ]),
    async fetchMainProgram() {
      this.loading = true
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.model.branch_id = this.$store.state.authUser.default_branch_id
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      this.getMainProgram()
        .then(response => {
          this.main_programs = [
            { value: 0, label: 'All' },
            ...response.data.map(el => ({
              value: el.acp_id,
              label: el.acp_name_foreign
            }))
          ]
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchTeacher(acp_id) {
      this.study_time_resources = []
      this.teacher_lists = []
      if (!acp_id) {
        return
      }
      this.loading = true
      this.getTeacher(acp_id)
        .then(response => {
          this.study_time_resources = response.data.map(el => ({
            teacher_id: el.teacher_resp_id,
            ac_st_id: el.ac_st_id,
            study_time: el.academic_study_time.study_time
          }))

          this.teacher_lists = [
            { value: 0, label: 'All' },
            ...response.data.map(el => ({
              value: el.teacher.teacher_id,
              label: el.teacher.full_name_en
            }))
          ]
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.paymentDetailExcel(this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'.indexOf('filename')]
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.paymentDetail(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
